import { render, staticRenderFns } from "./CustomerProposalSaveForm.vue?vue&type=template&id=bde4c780"
import script from "./CustomerProposalSaveForm.vue?vue&type=script&lang=js"
export * from "./CustomerProposalSaveForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerProposalSaveForm.vue?vue&type=style&index=0&id=bde4c780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports